import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from '../utils/intercepter/axiosConfig.js'
import { FaArrowDown } from "react-icons/fa";
import { AiOutlineCheckCircle } from 'react-icons/ai';


const Payer = () => {

    const {w_id} = useParams();

    const [montant, setMontant] = useState(0);
    const [num_tr_code, setNumTrCode] = useState(0);

    const fetchTrConservationByWId = async () => {
        try {

            const response = await api.post("/auth/getTrConservationOfMutation",{
                w_id: w_id
            });

            if(response.data.status){
                setMontant(response.data.response.montant);
                setNumTrCode(response.data.response.num_tr);
            }
            else{
                console.log("Aucun Information.")
            }
        } catch (error) {
            console.log("Erreur connexion.")
        }
    }

    useEffect(() => {
        if(w_id){
            fetchTrConservationByWId();
        }
    }, [w_id])


    const handleDownload = async () => {

            try {
                const response = await api.post("/auth/generatePdfConservation",{
                    num_tr: num_tr_code
                },{
                    responseType: "blob"
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;

                link.setAttribute("download",`Titre_Recette_${num_tr_code}.pdf`);
                document.body.appendChild(link);

                link.click();

                link.parentNode.removeChild(link);


            } catch (error) {
                console.log(error);
            }
    }
 
    return <div className="container mt-5">
        <h2 className="mb-4 text-center">Paiement</h2>

        <div className="card">
            <div className="card-body">
                <table className="table table-bordered">

                    <tbody>
                        <tr>

                        <td className="text-start">
                            Montant
                            </td>
                           <td>
                            {montant ? montant.toLocaleString() : "N/A"} MRU
                            </td> 
                        </tr>

                        <tr>
                        <td className="text-start">
                        Code
                            </td>
                           <td>
                           {num_tr_code.toLocaleString()}
                            </td> 
                        </tr>

                        <tr>
                        <td className="text-start">
                        Opérations
                            </td>
                           <td  className="d-flex align-items-center gap-2">
                           
                           <button className="btn btn-warning btn-sm d-flex align-items-center"
                           onClick={handleDownload}
                           >
                            <FaArrowDown size={20} style={{marginRight:'10px'}}
                            />
                                Télécharger
                               </button>

                                <button className="btn btn-success btn-sm d-flex align-items-center">
                                        <AiOutlineCheckCircle size={20} style={{ marginRight: '5px' }} />
                                        Payé
                                        </button>

                            </td> 
                        </tr>
                        

                    </tbody>
                </table>
            </div>
        </div>

    </div>
}

export default Payer;